export var ERROR_BAD_MAC = "Bad MAC";